module.exports = __webpack_public_path__ + "img/PRCA1_Mast.47d485ec.png";